<strong></strong><template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>财务结算</el-breadcrumb-item>
      <el-breadcrumb-item>收支明细</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card>
          <el-row :gutter="20">
            <el-col :span="4">
              <el-tooltip class="item" effect="light" content="时间范围" placement="top">
                <el-date-picker
                  v-model="queryInfo.timeHorizon"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="时间"
                  end-placeholder=" 范围"
                  size="mini"
                  style="width: 80%;">
                </el-date-picker>
              </el-tooltip>
            </el-col>
            <el-col :span="2" style="margin-left: -4%;">
              <el-tooltip class="item" effect="light" content="凭证号" placement="top">
                <el-input v-model="queryInfo.voucherNum" placeholder="凭证号" size="mini" style="width: 100%;"></el-input>
              </el-tooltip>
            </el-col>
            <el-col :span="2" style="margin-left: -1%;">
              <el-tooltip class="item" effect="light" content="内容备注" placement="top">
                <el-input v-model="queryInfo.contentRemark" placeholder="内容备注" size="mini" style="width: 100%;"></el-input>
              </el-tooltip>
            </el-col>
            <el-col :span="2" style="margin-left: -1%;">
              <el-tooltip class="item" effect="light" content="操作员" placement="top">
                <el-input v-model="queryInfo.operator" placeholder="操作员" size="mini" style="width: 100%;"></el-input>
              </el-tooltip>
            </el-col>
            <el-col :span="2" style="margin-left: -1%;">
              <el-tooltip class="item" effect="light" content="付款对象" placement="top">
                <el-input v-model="queryInfo.payObject" placeholder="付款对象" size="mini" style="width: 90%;"></el-input>
              </el-tooltip>
            </el-col>
            <el-col :span="2" style="margin-left: -1.5%;">
              <el-tooltip class="item" effect="light" content="收支科目" placement="top">
                <el-select v-model="queryInfo.earningSubject" placeholder="收支科目" size="mini" style="width: 100%;">
                  <el-option label="全部" value="全部"></el-option>
                  <el-option label="营业收入" value="营业收入"></el-option>
                  <el-option label="营业外收入" value="营业外收入"></el-option>
                  <el-option label="运营支出" value="运营支出"></el-option>
                  <el-option label="行政支出" value="行政支出"></el-option>
                  <el-option label="办公支出" value="办公支出"></el-option>
                  <el-option label="出差支出" value="出差支出"></el-option>
                  <el-option label="人员工资" value="人员工资"></el-option>
                  <el-option label="运输支出" value="运输支出"></el-option>
                  <el-option label="派送支出" value="派送支出"></el-option>
                  <el-option label="外包支出" value="外包支出"></el-option>
                </el-select>
              </el-tooltip>
            </el-col>
            <el-col :span="2" style="margin-left: -1%;">
              <el-tooltip class="item" effect="light" content="资金项目" placement="top">
                <el-select v-model="queryInfo.moneyType" placeholder="资金项目" size="mini" style="width: 80%;">
                  <el-option label="全部" value="全部"></el-option>
                  <el-option label="支出" value="支出"></el-option>
                  <el-option label="收入" value="收入"></el-option>
                </el-select>
              </el-tooltip>
            </el-col>
            <el-col :span="2" style="margin-left: -2%;">
              <el-tooltip class="item" effect="light" content="收支方式" placement="top">
                <el-select v-model="queryInfo.earningMode" placeholder="收支方式" size="mini" style="width: 90%;">
                  <el-option label="全部" value="全部"></el-option>
                  <el-option label="现金支付" value="现金支付"></el-option>
                  <el-option label="公司转账" value="公司转账"></el-option>
                </el-select>
              </el-tooltip>
            </el-col>
            <el-col :span="2" style="margin-left: -1.5%;">
              <el-tooltip class="item" effect="light" content="发生站点" placement="top">
                <el-select v-model="queryInfo.happenSite" placeholder="发生站点" size="mini" style="width: 90%;">
                  <el-option label="全部" value="全部"></el-option>
                  <el-option label="已审核" value="已审核"></el-option>
                  <el-option label="未审核" value="未审核"></el-option>
                </el-select>
              </el-tooltip>
            </el-col>
            <el-col :span="2" style="margin-left: -1.5%;">
              <el-tooltip class="item" effect="light" content="个人审核" placement="top">
                <el-select v-model="queryInfo.personallyAudit" placeholder="个人审核" size="mini" style="width: 80%;">
                  <el-option label="全部" value="全部"></el-option>
                  <el-option label="已审核" value="已审核"></el-option>
                  <el-option label="未审核" value="未审核"></el-option>
                </el-select>
              </el-tooltip>
            </el-col>
            <el-col :span="2" style="margin-left: -2%;">
              <el-tooltip class="item" effect="light" content="公司审核" placement="top">
                <el-select v-model="queryInfo.comAudit" placeholder="公司审核" size="mini" style="width: 80%;">
                  <el-option label="全部" value="全部"></el-option>
                  <el-option label="已审核" value="已审核"></el-option>
                  <el-option label="未审核" value="未审核"></el-option>
                </el-select>
              </el-tooltip>
            </el-col>
            <el-col :span="1" style="margin-left: -2%;">
              <el-tooltip class="item" effect="light" content="搜索或保留条件刷新,可在页面中使用回车键代替" placement="top">
                <el-button icon="el-icon-search" circle size="mini" @click="search()"></el-button>
              </el-tooltip>
            </el-col>
          </el-row>
          
          <el-row style="margin-top: 0.5%;">
            <el-col :span="2">
              <el-button type="primary" size="mini" @click="personallyAuditSub()">个人审核</el-button>
            </el-col>
            <el-col :span="2" style="margin-left: -2.5%;">
              <el-button type="primary" plain size="mini" @click="comAuditSub()">公司审核</el-button>
            </el-col>
            <el-col :span="2" style="margin-left: -2.5%;">
              <el-button type="info" size="mini" @click="exportExcel()">导出Excel</el-button>
            </el-col>
            <el-col :span="2" style="margin-left: -2.2%;">
              <el-button type="info" plain size="mini" @click="print()">打印表单</el-button>
            </el-col>
          </el-row>
          
          <el-table max-height="630" :data="otherCostInfoList" border style="width: 100%" size="mini"
            ref="multipleTable" tooltip-effect="dark" :row-class-name="tableRowClassName">
            <el-table-column prop="payNum" label="资金项目"></el-table-column>
            <el-table-column prop="payNum" label="收支日期"></el-table-column>
            <el-table-column prop="payNum" label="支出金额"></el-table-column>
            <el-table-column prop="payNum" label="收入金额"></el-table-column>
            <el-table-column prop="payNum" label="凭证号"></el-table-column>
            <el-table-column prop="payNum" label="收支科目"></el-table-column>
            <el-table-column prop="payNum" label="收支类型"></el-table-column>
            <el-table-column prop="payNum" label="进港站点"></el-table-column>
            <el-table-column prop="payNum" label="发生站点"></el-table-column>
            <el-table-column prop="payNum" label="收支方式"></el-table-column>
            <el-table-column prop="payNum" label="收支内容"></el-table-column>
            <el-table-column prop="payNum" label="操作员"></el-table-column>
            <el-table-column prop="payNum" label="付款对象"></el-table-column>
            <el-table-column prop="payNum" label="备注" width="200%" show-overflow-tooltip=false></el-table-column>
            <el-table-column prop="payNum" label="个人审核"></el-table-column>
            <el-table-column prop="payNum" label="审核人"></el-table-column>
            <el-table-column prop="payNum" label="公司审核"></el-table-column>
            <el-table-column prop="payNum" label="公司审核人"></el-table-column>
          </el-table>
    
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryInfo.pageNum"
            :page-sizes="[10,20,50,100,200,500]"
            :page-size="queryInfo.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            background
          >
          </el-pagination>
          
        </el-card>
        
      </div>
      
    </template>
    
<script>
  export default {
    data() {
      return {
        queryInfo: {
          contractor: "",
          epibolyNum: "",
          epibolySubject: "",
          orderNo: "",
          epibolyTime: "",
          pageNum: 1,
          pageSize: 10
        },
        otherCostInfoList: [
          {
            payNum: "xxx",
            epibolyTime: "外包时间",
            epibolySubject: "外包科目",
            orderNo: "原订单编号",
            contractor: "外包单位",
            phone: "电话",
            contacts: "联系人",
            addr: "地址",
            payCost: "支付费用",
            spotPaymentMoney: "现付金额",
            spotPaymentMode: "现付方式",
            unpaidMoney: "未付金额",
            productName: "是否付清",
            remarks: "备注"
          },
          {
            payNum: "xxx",
            epibolyTime: "外包时间",
            epibolySubject: "外包科目",
            orderNo: "原订单编号",
            contractor: "外包单位",
            phone: "电话",
            contacts: "联系人",
            addr: "地址",
            payCost: "支付费用",
            spotPaymentMoney: "现付金额",
            spotPaymentMode: "现付方式",
            unpaidMoney: "未付金额",
            productName: "是否付清",
            remarks: "备注"
          },
          {
            payNum: "xxx",
            epibolyTime: "外包时间",
            epibolySubject: "外包科目",
            orderNo: "原订单编号",
            contractor: "外包单位",
            phone: "电话",
            contacts: "联系人",
            addr: "地址",
            payCost: "支付费用",
            spotPaymentMoney: "现付金额",
            spotPaymentMode: "现付方式",
            unpaidMoney: "未付金额",
            productName: "是否付清",
            remarks: "备注"
          }
        ],
        total: 3,
        
        
      };
    },
    methods: {
      async getOrderList() {
        const { data } = await this.$http.get("orders", {
          params: this.queryInfo
        });
        if (data.meta.status !== 200) {
          return this.$message.error(data.meta.msg);
        }
        this.orderlist = data.data.goods;
        this.total = data.data.total;
        this.totalPag = data.data.totalPag;
      },
      // 加急标红
      tableRowClassName({row, rowIndex}) {
        if (row.orderType == "加急订单") {
          return 'warning-row';
        }
        return '';
      },
      //修改外包
      editEpiboly(index, otherCostInfo){
        //跳转到修改外包页
        //跳转到其他成本登记页
        let routeData = this.$router.resolve({path: 'other-cost',
                           query: {
                             orderNo: otherCostInfo.orderNo,
                             billingPerson: otherCostInfo.billingPerson,
                             epibolyTime: otherCostInfo.epibolyTime,
                             pageUpPath: '/epiboly/other-cost-list',
                             pageUpName: '其他成本'
                             }});
        window.open(routeData.href, '_blank');
        
      }
      
    },
    created() {
      
      var that = this
      //当前页面监视键盘输入
      document.onkeydown = function(e) {//事件对象兼容
          let e1 = e || event || window.event || arguments.callee.caller.arguments[0]
          //键盘按键判断:左箭头-37;上箭头-38；右箭头-39;下箭头-40;回车13
          //回车搜索
          if (e1 && e1.keyCode == 13) {
              that.search();
          }
          else if(e1 && e1.keyCode == 37)
          {
            if(that.queryInfo.pageNum > 1)
            {
              that.handleCurrentChange(that.queryInfo.pageNum - 1)
            }
          }
          else if(e1 && e1.keyCode == 39)
          {
            if(that.queryInfo.pageNum < that.totalPag)
            {
              that.handleCurrentChange(that.queryInfo.pageNum + 1)
            }
          }
      }
    }
  };
</script>

<style>
.el-cascader {
  width: 100%;
}
.el-table .warning-row {
  color: #ff0000;
}
</style>
